export enum NegativeMarkType {
  MISSED_PAYMENT = 'missed_payment',
  JUDGEMENT = 'judgement',
  INSOLVENCY = 'insolvency',
}
